export const FILTER_AND_SEARCH_REDUCER_STATE_ID = 'filterAndSearch';
export const FILTER_AND_SEARCH_REDUCER_HIERARCHY_STATE_ID =
  'filterAndSearchHierarchy';
